import { Paragraph } from '@tiptap/extension-paragraph';

/**
 * 自定义段落扩展
 * 扩展了基础段落组件，添加了ID属性支持
 * 用于标识段落，便于定位和内容追踪
 */
export const CustomParagraph = Paragraph.extend({
    addAttributes() {
        return {
            // 段落ID属性
            id: {
                default: null,
                parseHTML: (element) => element.getAttribute('id'),
                renderHTML: (attributes) => {
                    if (!attributes.id) {
                        return {};
                    }
                    return {
                        id: attributes.id,
                    };
                },
            },
        };
    },
});
